module.exports = __webpack_public_path__ + "img/discord-logo.73cd9521.svg";